export default {
	type: "chevron-right",
};
